import { gql } from '@apollo/client';

const GET_IPAD = gql`
    query getiPad($SerialNumber: String, $UDID: String) {
        configProfiles {
            PayloadDisplayName
            PayloadDescription
            PayloadOrganization
            PayloadIdentifier
            PayloadUUID
            MobileConfigData
        }
        ipad(SerialNumber: $SerialNumber, UDID: $UDID) {
            SerialNumber
            ProductName
            OSVersion
            UDID
            mdmProfileInstalled
            hasBootstrapToken
            assetTag
            assignedDirectoryUser {
                _id
                name
                firstName
                lastName
                username
                role
                className
                classes
                managedAppleId
                asmUserId
            }
            location {
                _id
                name
                schoolNumber
            }
            QueryResponses {
                AppAnalyticsEnabled
                AvailableDeviceCapacity
                AwaitingConfiguration
                BatteryLevel
                BluetoothMAC
                BuildVersion
                CellularTechnology
                DataRoamingEnabled
                DeviceCapacity
                DeviceName
                IsActivationLockEnabled
                IsCloudBackupEnabled
                IsDeviceLocatorServiceEnabled
                IsDoNotDisturbInEffect
                IsSupervised
                Model
                ModelName
                ModelNumber
                OSVersion
                PersonalHotspotEnabled
                ProductName
                SerialNumber
                SoftwareUpdateDeviceID
                SupplementalBuildVersion
                TimeZone
                UDID
                WiFiMAC
            }
            SecurityInfo {
                PasscodePresent
                PasscodeCompliant
                ManagementStatus {
                    IsUserEnrollment
                }
            }
            Applications {
              Identifier
              Name
              Version
            }
            disabledProfiles {
                PayloadIdentifier
                PayloadDisplayName
                disabledAt
            }
            assignedSettingsProfiles {
                profileId
                PayloadDisplayName
                PayloadIdentifier
                PayloadUUID
                PayloadDescription
                PayloadOrganization
                PayloadType
                kind
                source
                groupName
                hasInstallablePayload
            }
            assignedDeviceGroups {
                groupId
                groupName
            }
            enrollmentContext {
                hasDepAssignment
                depProfileUuid
                depProfileName
                depIsSupervised
            }
            Profiles {
                HasRemovalPasscode
                IsEncrypted
                IsManaged
                PayloadDescription
                PayloadDisplayName
                PayloadIdentifier
                PayloadOrganization
                PayloadType
                PayloadUUID
                PayloadVersion
                PayloadRemovalDisallowed
                PayloadContent {
                    PayloadDescription
                    PayloadDisplayName
                    PayloadIdentifier
                    PayloadOrganization
                    PayloadType
                    PayloadUUID
                    PayloadVersion
                }
              }
            CertificateList {
                CommonName
                IsIdentity
            }
            AvailableSoftwareUpdates {
                AllowsInstallLater
                Build
                DownloadSize
                InstallSize
                HumanReadableName
                HumanReadableNameLocale
                IsConfigDataUpdate
                IsCritical
                IsFirmwareUpdate
                IsSecurityResponse
                ProductKey
                ProductName
                RequiresBootstrapToken
                RestartRequired
                SupplementalBuildVersion
                Version
            }
            OSUpdateStatus {
                ProductKey
                Status
                DownloadPercentComplete
                IsDownloaded
            }
            OSUpdateResults {
                InstallAction
                ProductKey
                Status
                ErrorChain {
                    ErrorCode
                    ErrorDomain
                    LocalizedDescription
                    USEnglishDescription
                }
            }
            lastCheckedIn
            lastDdmStatusReportAt
            updatedAt
            bluetoothEnabled
            lostMode {
                enabled
                message
                phoneNumber
                footnote
                enabledAt
            }
            lostModeLocation {
                latitude
                longitude
                horizontalAccuracy
                timestamp
                retrievedAt
            }
            activationLockBypassCode {
                code
                retrievedAt
            }
        }
    }
`

export { GET_IPAD };
